import { render, staticRenderFns } from "./LeadStudentCard.vue?vue&type=template&id=06aabd1f"
import script from "./LeadStudentCard.vue?vue&type=script&lang=js"
export * from "./LeadStudentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports